import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=210d14e6&scoped=true&"
import script from "./DropFile.vue?vue&type=script&lang=js&"
export * from "./DropFile.vue?vue&type=script&lang=js&"
import style0 from "./DropFile.vue?vue&type=style&index=0&id=210d14e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210d14e6",
  null
  
)

export default component.exports